// import router from "@/router";
import apiEmployeeAccess from "@/services/employeeAccess/api/apiEmployeeAccess";
import { handleError } from "@/store/shared";
const endpoints = require("../../common/endpoints");
import { storeInLocalStorage } from "@/services/employeeAccess/login/loginService";
// import { getLocalStorageItem } from "@/utils/localStorageUtility";
// import { routeNames } from "@/router/solution/solutionRoutes";
const actions = {
  initAppSettings({ commit }, appSettings) {
    commit("SET_APP_SETTINGS", appSettings);
  },
  initKeycloak({ commit }, keycloak) {
    commit("SET_KEYCLOAK", keycloak);
  },
  logIn({ commit }) {
    commit("SET_USER");
  },
  logOut({ commit }) {
    // router.push({ name: routeNames.permissions });
    commit("LOGOUT");
  },
  async setPermissions({ commit }, payload) {
    return apiEmployeeAccess
      .cityCenterApiGetWithoutPayload(endpoints.user_permissions + payload)
      .then(response => {
        const data = response.data;
        if (data.code === 200) {
          if (data.data !== null) {
            const sortedPermissions = storeInLocalStorage(data);
            commit("SET_PERMISSIONS", sortedPermissions);
          }
        }
      })
      .catch(error => handleError(error, `Unable to set Permissions`));
  }
};

export default actions;
